import { Link } from '@tanstack/react-router'
import { ReactNode } from 'react'

import { cn } from '@/utils/cn'

interface Props {
    title: ReactNode
    linkTo?: string
    linkParams?: Record<string, string>
    subtitle?: ReactNode
    children?: ReactNode
    controls?: ReactNode
    className?: string
}

export default function PageHeader({ className, title, subtitle, controls, children, linkTo, linkParams = {} }: Props) {
    const titleCmp = linkTo ? (
        <Link to={linkTo} params={linkParams}>
            {title}
        </Link>
    ) : (
        title
    )
    return (
        <div className={cn(className)}>
            <div className="flex h-16 items-center">
                <h2 className="mb-2 flex flex-grow items-center">
                    {titleCmp}
                    {children}
                </h2>
                {controls}
            </div>
            {subtitle ? <p className="text-sm text-muted-foreground">{subtitle}</p> : null}
        </div>
    )
}
